import React from 'react';
import { Card } from 'tea-component';
import LoadingCommon from '../LoadingCommon';
import './index.scss';

export default function CardLoading({
  children,
  loading,
  wrapperStyle = {},
  ...otherProps
}: {
  children:
    | Array<JSX.Element | Element | boolean>
    | JSX.Element
    | Element
    | boolean;
  loading: boolean;
  wrapperStyle?: any;
  [key: string]: any;
}) {
  return (
    <div
      className="main-info-box dbo-card-loading-wrapper"
      style={wrapperStyle}
    >
      {loading ? (
        <Card>
          <Card.Body className="dbo-card-loading-body">
            <LoadingCommon {...otherProps} status="loading"></LoadingCommon>
          </Card.Body>
        </Card>
      ) : (
        <>{children}</>
      )}
    </div>
  );
}
